import React, { Suspense } from 'react';
import { withAuthenticator } from '@aws-amplify/ui-react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import authComponents from '../auth';
import Agreement from '../licensionAgreement';
import { themes } from '../../share/themes';
import { useAgreement } from './hooks/use-agreement';
import AppContainer from '../../share/components/appContainer';
import AuthUtils from '../../share/utils/network/AuthUtils';
import { initApp } from './init';
import LinearLoader from '../../share/components/customLoader';
import * as PATHS from '../../share/constants/paths';

const Projects = React.lazy(() => import('../projects'));
const LotType = React.lazy(() => import('../lotType'));
const LotEditor = React.lazy(() => import('../lotEditor'));
const LocateTypical = React.lazy(() => import('../locateTypical'));
const SchematicView = React.lazy(() => import('../schematicView'));

AuthUtils.init();

function App() {
  initApp();
  const { agreement, handleAgree } = useAgreement();
  return (
    <ThemeProvider theme={themes}>
      {!agreement ? <Agreement handleAgree={handleAgree} />
        : (
          <AppContainer>
            <CssBaseline />
            <Suspense fallback={<LinearLoader />}>
              <Routes>
                <Route
                  path={PATHS.PATH_PROJECTS}
                  element={<Projects />}
                />
                <Route
                  path={PATHS.PATH_LOT_TYPE}
                  element={<LotType />}
                />
                <Route
                  path={PATHS.PATH_LOT_EDITOR}
                  element={<LotEditor />}
                />
                <Route
                  path={PATHS.PATH_LOCATE_TYPICAL}
                  element={<LocateTypical />}
                />
                <Route
                  path={PATHS.SCHEMATIC_VIEW}
                  element={<SchematicView />}
                />
                <Route
                  path="*"
                  element={<Navigate to={PATHS.PATH_PROJECTS} replace />}
                />
              </Routes>
            </Suspense>
          </AppContainer>
        )}
    </ThemeProvider>
  );
}

export default withAuthenticator(App, authComponents);
